import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import ThemeQuery from './__generated__/ThemeQuery.graphql.ts';
export function preloadPageLayout() {
	return query({
		query: ThemeQuery,
	});
}
